export const TOOLTIP_PLACEMENT = {
  top: 'top',
  topStart: 'top-start',
  topEnd: 'top-end',

  right: 'right',
  rightStart: 'right-start',
  rightEnd: 'right-end',

  bottom: 'bottom',
  bottomStart: 'bottom-start',
  bottomEnd: 'bottom-end',

  left: 'left',
  leftStart: 'left-start',
  leftEnd: 'left-end',

  auto: 'auto',
  autoStart: 'auto-start',
  autoEnd: 'auto-end',
};

export const TOOLTIP_TRIGGER = {
  mouseEnterFocus: 'mouseenter focus', //default
  click: 'click',
  focusin: 'focusin',
  mouseEnterClick: 'mouseenter click',
  manual: 'manual',
};

export const TOOLTIP_DISTANCE = 10;
